export default __webpack_public_path__ + "static/media/card-2.a92b5f10.webp";